import "./Device.component.scss";

const Device = (props: any) => {
  const {
    reader,
    action,
    isSelected,
    onClick,
  } = props;

  return (
    <li onClick={() => onClick()} className={`list-group-item cursor-pointer ${isSelected ? "selected" : ""}`}>
      <div className="row align-items-center">
        <div className="col-3">
          <img src="images/reader-white-light.png" alt="" className="img-fluid" />
        </div>
        <div className="col">
          <strong>{reader.name}</strong>
          <br />
          <small className="text-muted">
            Serial Number: {reader.serialNumber || ""}<br />
            Firmware Version: {reader.firmwareVersion || ""}<br />
            Status: <small className="text-muted">(see notes)</small>
          </small>
        </div>

        {action === "open_details" && <>
          <div className="col-1 text-end">
            <i className="fas fa-chevron-right"></i>
          </div>
        </>}
      </div>
    </li>
  )
};

export default Device;